











import { Component, Prop, Vue } from "vue-property-decorator";
import { IMerchant } from "@/store/interfaces/merchant";
import { addGoal, EGoal } from "@/services/addYGoal.ts";

@Component({
  name: "MerchantCard"
})
export default class MerchantCard extends Vue {
  @Prop({ default: null })
  merchant: IMerchant;
  currentLang: string =
    localStorage.getItem("currentLang") === "br"
      ? "br"
      : localStorage.getItem("currentLang");

  async handleClick() {
    await addGoal(EGoal.merchant_click);
    this.$router.push({
      path: `/${this.currentLang}/merchant/${this.merchant.id}`
    });
  }
}
